import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import TermsAndConditions from "@/pages/TermsAndConditions";

export const Route = createFileRoute("/en/terms-and-conditions")({
  head: () => buildRouteHead("/en/terms-and-conditions"),
  component: TermsAndConditions,
});

